import React from 'react';
import { Link } from 'react-router';
import { IoMdOpen } from 'react-icons/io';
import { LAST_UPDATED_COLUMN } from '../shared-constants';
import {
  prettyPhone,
  formatEIN,
  required,
  phoneNumberVal,
  emailVal,
  taxIDVal,
} from '../../helpers/utils';
import DeadlineCell from '../../components/DeadlineCell';
import { Theme } from '../../theme';
import TableLink from '../../components/TableLink';

export const FUNDERS_COLUMNS = [
  {
    Header: 'Name',
    accessor: 'name',
    Cell: ({ cell: { value: funder }, row: { original } }) => {
      return (
        <TableLink to={`/funders/edit/${original.id}`}>{funder}</TableLink>
      );
    },
  },
  {
    Header: 'Address',
    accessor: 'address',
  },
  {
    Header: 'City',
    accessor: 'city',
  },
  {
    Header: 'State',
    accessor: 'state',
  },
  {
    Header: 'Projects',
    accessor: 'visible_projects',
    alignRight: true,
    // Sorting is server side and this column is not in FunderController's
    // allowlist, so a click would silently return the default order.
    disableSortBy: true,
    Cell: ({ cell: { value } }) => <span>{value.length}</span>,
  },
  { ...LAST_UPDATED_COLUMN },
];

export const FUNDER_PROJECTS_COLUMNS = [
  {
    Header: 'Deadline',
    accessor: 'deadline',
    Cell: (props) => <DeadlineCell {...props} typeOverride="project" />,
  },
  {
    Header: 'Client',
    accessor: 'client.name',
  },
  {
    Header: 'Req',
    accessor: 'amount_requested',
    Cell: ({ cell: { value } }) => value && value,
  },
  {
    Header: 'Status',
    accessor: 'status',
    Cell: ({ cell: { value } }) => value && value,
  },
  {
    Header: '',
    accessor: 'edit',
    Cell: ({
      row: {
        original: { id },
      },
    }) => {
      return (
        <Link
          {...({ to: `/projects/edit/${id}`, variant: 'primaryText' } as any)}
        >
          <IoMdOpen fontSize={18} color={Theme.colors.primary} />
        </Link>
      );
    },
  },
];

export const FUNDER_TYPES = [
  { value: 'Foundation', label: 'Foundation' },
  {
    label: 'Corporate Foundation',
    value: 'Corporate Foundation',
  },
  {
    label: 'Community Foundation',
    value: 'Community Foundation',
  },
  {
    label: "Federal Gov't",
    value: "Federal Gov't",
  },
  {
    label: "State Gov't",
    value: "State Gov't",
  },
  {
    label: "County Gov't",
    value: "County Gov't",
  },
  {
    label: "Local Gov't",
    value: "Local Gov't",
  },
  {
    label: 'Civic Organization',
    value: 'Civic Organization',
  },
  {
    label: 'Donor Advised Fund',
    value: 'Donor Advised Fund',
  },
  {
    label: "Foreign Gov't",
    value: "Foreign Gov't",
  },
  {
    label: 'Other',
    value: 'Other',
  },
  {
    label: 'None',
    value: 'None',
  },
];

export const FIELDS = [
  {
    name: 'name',
    label: 'Legal Name',
    validate: required,
  },
  {
    name: 'tax_id',
    label: 'Tax ID/EIN',
    transformOnBlur: formatEIN,
    validate: taxIDVal,
  },
  {
    name: 'type',
    label: 'Type',
    component: 'select',
    options: FUNDER_TYPES,
  },
  {
    name: 'phone',
    label: 'Phone',
    transformOnBlur: prettyPhone,
    validate: phoneNumberVal,
  },
  {
    name: 'fax',
    label: 'Fax',
    transformOnBlur: prettyPhone,
    validate: phoneNumberVal,
  },
  {
    name: 'email',
    label: 'Email',
    validate: emailVal,
  },
  {
    name: 'address',
    label: 'Address',
  },
  {
    name: 'city',
    label: 'City',
  },
  {
    name: 'state',
    label: 'State',
    component: 'select',
  },
  {
    name: 'country',
    label: 'Country',
    component: 'select',
    validate: required,
  },
  {
    name: 'zip',
    label: 'Zip',
  },
  {
    name: 'website',
    label: 'Website',
  },
  {
    name: 'empty',
    label: '',
  },
  {
    name: 'notes',
    label: 'Notes',
    multiline: true,
  },
];
